var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "vbiws9gama",
    d: "M0 0.023L529.001 0.023 529.001 529 0 529z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.5 10) translate(0 .977)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sex3b5wxub",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vbiws9gama"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M264.5 17.038c-7.924 0-15.847 3.016-21.879 9.048L26.063 242.644C20.219 248.489 17 256.259 17 264.523c0 8.265 3.219 16.035 9.063 21.879L242.621 502.96c12.065 12.063 31.694 12.063 43.759 0L502.937 286.4c5.845-5.843 9.064-13.613 9.064-21.878 0-8.264-3.219-16.034-9.064-21.88L286.379 26.087c-6.032-6.032-13.955-9.048-21.879-9.048m0 511.962c-12.277 0-24.554-4.672-33.899-14.018L14.042 298.422C4.987 289.369 0 277.33 0 264.523c0-12.804 4.987-24.843 14.042-33.9L230.6 14.066C239.655 5.01 251.694.023 264.5.023c12.806 0 24.845 4.987 33.9 14.042l216.559 216.558c9.055 9.056 14.042 21.095 14.042 33.9 0 12.806-4.987 24.845-14.042 33.9L298.4 514.982C289.054 524.328 276.776 529 264.5 529",
    mask: "url(#sex3b5wxub)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7CD9C2",
    d: "M388.667 208.972c-8.385-8.387-19.538-13.006-31.405-13.006-3.87 0-7.681.493-11.38 1.47l-41.019-41.018c4.016-15.186-.254-31.505-11.535-42.785-8.386-8.386-19.54-13.005-31.407-13.005-3.869 0-7.679.493-11.378 1.47L201.306 52.86l-5.582-5.582-5.582 5.582-20.465 20.465-5.582 5.583 5.582 5.582 49.237 49.236c-4.017 15.184.253 31.504 11.535 42.786 2.864 2.863 6.121 5.305 9.728 7.294v116.669c-13.578 7.897-22.099 22.455-22.099 38.41 0 24.517 19.946 44.463 44.464 44.463 24.518 0 44.463-19.946 44.463-44.463 0-15.955-8.522-30.513-22.098-38.411V199.72l29.346 29.344c-4.017 15.187.253 31.506 11.536 42.786 8.397 8.397 19.563 13.023 31.439 13.023 11.877 0 23.043-4.626 31.44-13.024 8.397-8.397 13.022-19.562 13.022-31.438 0-11.876-4.625-23.041-13.023-31.44",
    transform: "translate(10.5 10)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGit);
export default __webpack_public_path__ + "static/media/icon--git.6ab8e2711f6cb694b342e00950260241.svg";
export { ForwardRef as ReactComponent };